import axios from "axios";
import Config from "./config";


export const showFileURL = async (path) => {
    if (!path) {
        console.error("Invalid file path.");
        return;
    }

    const newTab = window.open("about:blank", "_blank");

    try {
        const res = await axios.get(
            `${Config.apiserver}gets3fileurl`,
            {
                params: {
                    file_key: path,
                },
            }
        );

        if (res.data?.status === 1 && res.data?.url) {
            if (newTab) {
                newTab.location.href = res.data.url;
            } else {
                window.location.href = res.data.url;
            }
        } else {
            if (newTab) newTab.close();
            console.error("Unable to generate file URL.");
        }
    } catch (error) {
        if (newTab) newTab.close();
        console.error("Error opening file:", error);
    }
};
